import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import { FDDialogTitle } from '@facet-wealth/design';
import { MaybeBoolSelect } from './Layout/MaybeBoolSelect';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride(['basicsTitle', 'payDetailsTitle'], {
    _component: () => TitleTextLarge,
  }, overrideReadOnly)
  .nameOverride(['startType', 'endType'], {
    _component: () => MaybeBoolSelect,
  }, overrideReadOnly);
